import { translations } from 'locales/i18n';
import * as yup from 'yup';

export const ioCourseValidationSchema = t =>
  yup.object().shape(
    {
      orderNumber: yup.number(),
      courseNumber: yup.string().required(t(translations.validation.required())),
      courseName: yup.string().required(t(translations.validation.required())),
      courseOfficer: yup.string().required(t(translations.validation.required())),
      degree: yup.string().required(t(translations.validation.required())),
      ectCount: yup.number().required(t(translations.validation.required())),
      faculty: yup.string().required(t(translations.validation.required())),
      isWinter: yup.boolean().when(['isSummer', 'isWinter'], {
        is: (isSummer, isWinter) => !isWinter && !isSummer,
        then: yup.boolean().isTrue(t(translations.validation.summerOrWinter())),
        otherwise: yup.boolean()
      }),
      isSummer: yup.boolean().when(['isSummer', 'isWinter'], {
        is: (isSummer, isWinter) => !isWinter && !isSummer,
        then: yup.boolean().isTrue(t(translations.validation.summerOrWinter())),
        otherwise: yup.boolean()
      }),
      isAWPM: yup.boolean().required(t(translations.validation.required())),
      courseDescription: yup.string().notRequired().nullable()
    },
    [
      ['isWinter', 'isWinter'],
      ['isWinter', 'isSummer'],
      ['isSummer', 'isWinter'],
      ['isSummer', 'isSummer']
    ]
  );
